module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/443.832e58d9.png";